'use client';

import { useMemo } from 'react';
import { Box, Tooltip } from '@/primitives';
import ImageWithSkeleton from '@/components/utils/ImageWithSkeleton';
import usePublicSearchContext from '@/publicSearch/store/usePublicSearchContext';
import { useDocumentImageWithSociety } from '@/hooks/publicSearch/useDocumentImageWithSociety';

/**
 * Society studbook logo for the site header (beside BreedLOGIC).
 */
export default function SocietySearchHeaderLogo() {
  const society = usePublicSearchContext((context) => context.society);

  const logoUrl = useMemo(
    () => society.settings?.find((setting) => setting.url)?.url,
    [society.settings],
  );
  const societyId = society.societyId ?? society.orgId ?? '';
  const { imgSrc: logoSrcWithSociety, isLoading: logoImageLoading } =
    useDocumentImageWithSociety(logoUrl ?? null, societyId);
  const logoTooltip = useMemo(
    () => society.settings?.find((setting) => setting.tooltip)?.tooltip,
    [society.settings],
  );
  const logoSettingUrl = useMemo(
    () => society.settings?.find((setting) => setting.settingUrl)?.settingUrl,
    [society.settings],
  );
  const shouldShow = society.loading || !!logoUrl;

  if (!shouldShow || !logoUrl) return null;

  return (
    <Tooltip title={logoTooltip || ''}>
      <Box
        onClick={() => {
          if (logoSettingUrl) {
            window.open(logoSettingUrl, '_blank', 'noopener,noreferrer');
          }
        }}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: logoSettingUrl ? 'pointer' : 'default',
          flexShrink: 0,
          height: '36px',
          width: 'auto',
        }}
      >
        <ImageWithSkeleton
          alt={society.name || 'Society logo'}
          height={36}
          width={96}
          src={logoSrcWithSociety ?? ''}
          isLoading={society.loading || logoImageLoading}
          containerSx={{
            height: '36px',
            width: 'auto',
          }}
          imageStyle={{
            height: '36px',
            maxHeight: '36px',
            width: 'auto',
            maxWidth: 'none',
          }}
        />
      </Box>
    </Tooltip>
  );
}
